import { useState } from "react";

export default function CustomDropdown({
  options = [],
  valueKey,
  labelKey,
  value,
  onChange,
  onOpen,
  placeholder = "Select",
}) {
  const [open, setOpen] = useState(false);

  const selected = options.find(
    (item) => item[valueKey] === value
  );

   const handleToggle = () => {
    if (!open && onOpen) {
      onOpen();
    }

    setOpen(!open);
  };

  return (
    <div className="relative w-full">
      <button
        type="button"
        onClick={handleToggle}
        className="w-full border rounded-md p-2 flex justify-between items-center bg-white"
      >
        {selected ? selected[labelKey] : placeholder}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform ${
            open ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <ul className="absolute z-50 mt-1 w-full max-h-48 overflow-y-auto bg-white border rounded-md shadow-lg">
          {options.map((item, index) => (
            <li
              key={index}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onChange(item);
                setOpen(false);
              }}
            >
              {item[labelKey]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}